// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLine_root__w6K9B"};